import allbirdsWhite from "./logos/allbirds-white.png?url";
import ballerinaFarmWhite from "./logos/ballerina-farm-white.png?url";
import baseballismWhite from "./logos/baseballism-white.webp?url";
import batchWhite from "./logos/batch-white.png?url";
import campSnapWhite from "./logos/camp-snap-white.png?url";
import cozyEarthWhite from "./logos/cozy-earth-white.webp?url";
import malbonWhite from "./logos/malbon-white.webp?url";
import mocoWhite from "./logos/moco-white.png?url";
import nikeStrengthWhite from "./logos/nike-strength-white.webp?url";
import popflexWhite from "./logos/popflex-white.webp?url";
import portlandLeatherWhite from "./logos/portland-leather-white.webp?url";
import sanctuaryClothingWhite from "./logos/sanctuary-clothing-white.png?url";
import vonDutchWhite from "./logos/von-dutch-white.png?url";
import wolfpakWhite from "./logos/wolfpak-white.webp?url";

export interface LoginLogo {
  name: string;
  /** White-on-transparent artwork for the dark hero panel. */
  src: string;
}

/** Merchant logos shown over the dark login/onboarding hero panel. */
export const LOGIN_LOGO_POOL: readonly LoginLogo[] = [
  { name: "popflex", src: popflexWhite },
  { name: "nike strength", src: nikeStrengthWhite },
  { name: "baseballism", src: baseballismWhite },
  { name: "wolfpak", src: wolfpakWhite },
  { name: "portland leather", src: portlandLeatherWhite },
  { name: "cozy earth", src: cozyEarthWhite },
  { name: "malbon", src: malbonWhite },
];

/** Merchants shipping with Redo, for the shipping-fulfillment signup hero. */
export const SHIPPING_LOGO_POOL: readonly LoginLogo[] = [
  { name: "allbirds", src: allbirdsWhite },
  { name: "von dutch", src: vonDutchWhite },
  { name: "moco", src: mocoWhite },
  { name: "sanctuary clothing", src: sanctuaryClothingWhite },
  { name: "ballerina farm", src: ballerinaFarmWhite },
  { name: "batch", src: batchWhite },
  { name: "camp snap", src: campSnapWhite },
];
